var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label label--anchor-page-badge",class:{'label-md': _vm.size === 'md'}},[_vm._v("\n  Anchor\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }